import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/master.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const moment = require('moment')
require('moment/locale/es') 
Vue.use(require('vue-moment'), {moment})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
